"use client";

import { Box } from "@ecco/ui/box";
import { FullBleed } from "@ecco/ui/full-bleed";
import { Container } from "@ecco/ui/container";
import { LazyNewsletterSignup } from "@components/newsletter-subscription/LazyNewsletterSignup";
import { Suspense, useEffect, useRef, useState } from "react";
import { styles } from "./FooterEmailSubscription.style";
import { useNewsletterFooterState } from "./hooks/useNewsletterFooterState";

export const FooterEmailSubscription = () => {
    const { shouldRenderNewsletterFooter } = useNewsletterFooterState();
    const placeholderRef = useRef<HTMLDivElement | null>(null);
    const [shouldRenderNewsletter, setShouldRenderNewsletter] = useState(false);

    useEffect(() => {
        if (!shouldRenderNewsletterFooter || shouldRenderNewsletter) return;

        const placeholder = placeholderRef.current;
        if (!placeholder || typeof IntersectionObserver === "undefined") {
            setShouldRenderNewsletter(true);
            return;
        }

        const observer = new IntersectionObserver(
            (entries) => {
                if (entries.some((entry) => entry.isIntersecting)) {
                    setShouldRenderNewsletter(true);
                }
            },
            { rootMargin: "600px 0px" }
        );

        observer.observe(placeholder);

        return () => observer.disconnect();
    }, [shouldRenderNewsletterFooter, shouldRenderNewsletter]);

    if (!shouldRenderNewsletterFooter) return null;

    return (
        <FullBleed {...styles.footer}>
            <Container maxW="container.largeDesktop" px={0}>
                {shouldRenderNewsletter ? (
                    <Suspense fallback={<Box {...styles.newsletterPlaceholder} />}>
                        <LazyNewsletterSignup />
                    </Suspense>
                ) : (
                    <Box
                        ref={placeholderRef}
                        data-testid="subscription-form-placeholder"
                        {...styles.newsletterPlaceholder}
                    />
                )}
            </Container>
        </FullBleed>
    );
};
